<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1><font-awesome-icon icon="hand-holding-usd" /> Nạp hạn mức cho khách của đối tác</h1>
      </div>
      <div v-if="canCreate">
        <button class="btn btn-success" @click="openCreate">
          <font-awesome-icon icon="plus" /> Tạo lệnh nạp hạn mức
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs">
          <li class="nav-item" v-for="tab in statusTabs" :key="tab.value">
            <a class="nav-link" href="#" :class="{ active: filterFormModel.status === tab.value }"
               @click.prevent="changeStatus(tab.value)">{{ tab.label }}</a>
          </li>
        </ul>
      </div>

      <div class="col-12">
        <div class="tile">
          <div class="form-inline mb-2">
            <admin-user-select v-if="!isAgency" class="mr-1 mb-1" style="min-width:220px"
                               :model="filterFormModel" attribute="agency" roleFilter="agency"
                               place-holder="Lọc theo đối tác"></admin-user-select>
            <client-select class="mr-1 mb-1" :model="filterFormModel" attribute="client" @change="load" />
            <button @click="load" class="btn btn-primary mr-1 mb-1">Tìm</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>

          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th v-if="!isAgency">Đối tác</th>
                  <th>Khách hàng</th>
                  <th class="text-right">Hạn mức nạp</th>
                  <th>Diễn giải</th>
                  <th>Người gửi</th>
                  <th>Ngày</th>
                  <th>Trạng thái</th>
                  <th class="text-right">Hành động</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!items.length">
                  <td :colspan="isAgency ? 8 : 9" class="text-center text-muted py-3">Không có lệnh nào</td>
                </tr>
                <tr v-for="(item, idx) in items" :key="item._id">
                  <td>{{ idx + 1 }}</td>
                  <td v-if="!isAgency">{{ item.agency ? item.agency.name : '-' }}</td>
                  <td>
                    <div><b>{{ item.client ? (item.client.companyName || item.client.domain) : '-' }}</b></div>
                    <div class="small text-muted" v-if="item.status === 'approved' && item.creditLimitAfter != null">
                      Hạn mức: {{ fmt(item.creditLimitBefore) }} → <b>{{ fmt(item.creditLimitAfter) }}</b>
                    </div>
                  </td>
                  <td class="text-right text-success"><b>+{{ fmt(item.amount) }}</b></td>
                  <td class="small">{{ item.note || '-' }}</td>
                  <td class="small">{{ item.createdBy ? item.createdBy.name : '-' }}</td>
                  <td class="small">{{ formatTime(item.createTime) }}</td>
                  <td>
                    <span class="badge" :class="statusClass(item.status)">{{ statusLabel(item.status) }}</span>
                    <div class="small text-muted" v-if="item.status === 'approved' && item.approvedBy">Duyệt: {{ item.approvedBy.name }}</div>
                    <div class="small text-danger" v-if="item.status === 'rejected' && item.rejectReason" :title="item.rejectReason">
                      Lý do: {{ item.rejectReason }}
                    </div>
                  </td>
                  <td class="text-right" style="white-space:nowrap">
                    <template v-if="item.status === 'pending' && canProcess">
                      <button class="btn btn-sm btn-success mr-1" @click="approve(item)">Duyệt</button>
                      <button class="btn btn-sm btn-danger" @click="openReject(item)">Từ chối</button>
                    </template>
                    <button v-if="item.status === 'rejected' && canDelete(item)" class="btn btn-sm btn-outline-danger"
                            @click="remove(item)" title="Xoá lệnh đã từ chối">
                      <font-awesome-icon icon="trash" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal tạo lệnh -->
    <b-modal v-model="createVisible" title="Tạo lệnh nạp hạn mức" hide-footer centered no-close-on-backdrop>
      <div class="alert alert-warning small">
        <font-awesome-icon icon="exclamation-triangle" />
        <b> Cảnh báo trách nhiệm:</b> Lệnh này khi được Callio (Account / Kế toán) duyệt sẽ cộng vào
        <b>HẠN MỨC</b> (không phải số dư) của khách hàng — khách được dùng dịch vụ ghi nợ tới hạn mức.
        Bạn (đối tác) <b>chịu trách nhiệm thanh toán công nợ</b> phát sinh với Callio cho phần hạn mức đã cấp.
      </div>
      <div class="form-group">
        <label>Khách hàng <span class="text-danger">*</span></label>
        <client-select :model="createForm" attribute="client" />
      </div>
      <div class="form-group">
        <label>Số tiền hạn mức nạp (đ) <span class="text-danger">*</span></label>
        <input type="number" min="1" class="form-control" v-model.number="createForm.amount" placeholder="VD: 5000000" />
        <small class="text-muted" v-if="createForm.amount > 0">= {{ fmt(createForm.amount) }} đ</small>
      </div>
      <div class="form-group">
        <label>Diễn giải</label>
        <textarea class="form-control" rows="2" v-model="createForm.note" maxlength="1000"
                  placeholder="VD: Khách đã chuyển khoản 5.000.000đ ngày..."></textarea>
      </div>
      <div class="text-right">
        <button class="btn btn-secondary mr-2" @click="createVisible = false">Huỷ</button>
        <button class="btn btn-success" :disabled="acting || !createForm.client || !(createForm.amount > 0)" @click="doCreate">
          Gửi lệnh
        </button>
      </div>
    </b-modal>

    <!-- Modal từ chối -->
    <b-modal v-model="rejectVisible" title="Từ chối lệnh nạp hạn mức" hide-footer centered>
      <div class="form-group">
        <label>Lý do từ chối <span class="text-danger">*</span></label>
        <textarea class="form-control" rows="3" v-model="rejectReason" maxlength="500"
                  placeholder="Nhập lý do để đối tác biết"></textarea>
      </div>
      <div class="text-right">
        <button class="btn btn-secondary mr-2" @click="rejectVisible = false">Huỷ</button>
        <button class="btn btn-danger" :disabled="acting || !rejectReason.trim()" @click="doReject">Xác nhận từ chối</button>
      </div>
    </b-modal>
  </main>
</template>

<script>
import moment from 'moment';
import List from '@/mixins/List';
import ClientSelect from '@/components/ClientSelect.vue';
import AdminUserSelect from '@/components/AdminUserSelect';

export default {
  mixins: [List],
  components: { ClientSelect, AdminUserSelect },
  data() {
    return {
      service: '/partner-credit',
      autoLoad: true,
      defaultFilterFormModel: { page: 1, pageSize: 50, status: 'pending', client: null, agency: null },
      statusTabs: [
        { value: 'pending', label: 'Chờ duyệt' },
        { value: 'approved', label: 'Đã duyệt' },
        { value: 'rejected', label: 'Đã từ chối' },
      ],
      createVisible: false,
      createForm: { client: null, amount: null, note: '' },
      rejectVisible: false,
      rejectReason: '',
      rejectTarget: null,
      acting: false,
    };
  },
  computed: {
    role() { return this.$store.state.user.role; },
    isAgency() { return this.role === 'agency'; },
    canCreate() { return this.role === 'agency'; },
    canProcess() { return ['owner', 'admin', 'account', 'accountant'].includes(this.role); },
  },
  methods: {
    changeStatus(status) {
      this.filterFormModel.status = status;
      this.load();
    },
    fmt(n) { return (n != null) ? Number(n).toLocaleString('vi-VN') : '0'; },
    formatTime(t) { return t ? moment(t).format('DD/MM/YYYY HH:mm') : '-'; },
    statusLabel(s) { return { pending: 'Chờ duyệt', approved: 'Đã duyệt', rejected: 'Đã từ chối' }[s] || s; },
    statusClass(s) { return { pending: 'badge-warning', approved: 'badge-success', rejected: 'badge-danger' }[s] || 'badge-secondary'; },
    canDelete(item) {
      if (['owner', 'admin'].includes(this.role)) return true;
      return this.isAgency && item.agency && (item.agency._id === this.$store.state.user._id || item.agency === this.$store.state.user._id);
    },
    openCreate() {
      this.createForm = { client: null, amount: null, note: '' };
      this.createVisible = true;
    },
    doCreate() {
      if (!this.createForm.client || !(this.createForm.amount > 0)) return;
      this.acting = true;
      this.$service.post(this.service, {
        client: this.createForm.client,
        amount: this.createForm.amount,
        note: this.createForm.note,
      }).then(() => {
        this.createVisible = false;
        this.$swal({ title: 'Đã gửi lệnh', text: 'Chờ Callio duyệt.', icon: 'success', toast: true, position: 'top-end', timer: 3000 });
        this.load();
      }).catch(error => {
        const msg = error.response && error.response.data && (error.response.data.message || error.response.data.msg);
        this.$swal({ text: msg || 'Có lỗi xảy ra', icon: 'error' });
      }).finally(() => { this.acting = false; });
    },
    approve(item) {
      this.$swal({
        title: 'Duyệt lệnh nạp hạn mức?',
        html: `Sẽ nạp hạn mức <b>${this.fmt(item.amount)}đ</b> cho <b>${item.client ? (item.client.companyName || item.client.domain) : ''}</b> (hạn mức giảm về phía âm).`,
        icon: 'question', showCancelButton: true, confirmButtonText: 'Duyệt', cancelButtonText: 'Huỷ',
      }).then(result => {
        if (!result.value) return;
        const loader = this.$loading.show();
        this.$service.post(`${this.service}/${item._id}/approve`).then(() => {
          this.$swal({ title: 'Đã duyệt', icon: 'success', toast: true, position: 'top-end', timer: 3000 });
          this.load();
        }).catch(error => {
          const msg = error.response && error.response.data && (error.response.data.message || error.response.data.msg);
          this.$swal({ text: msg || 'Có lỗi xảy ra', icon: 'error' });
        }).finally(() => loader.hide());
      });
    },
    openReject(item) {
      this.rejectTarget = item;
      this.rejectReason = '';
      this.rejectVisible = true;
    },
    doReject() {
      this.acting = true;
      this.$service.post(`${this.service}/${this.rejectTarget._id}/reject`, { reason: this.rejectReason }).then(() => {
        this.rejectVisible = false;
        this.$swal({ title: 'Đã từ chối', icon: 'success', toast: true, position: 'top-end', timer: 3000 });
        this.load();
      }).catch(error => {
        const msg = error.response && error.response.data && (error.response.data.message || error.response.data.msg);
        this.$swal({ text: msg || 'Có lỗi xảy ra', icon: 'error' });
      }).finally(() => { this.acting = false; });
    },
    remove(item) {
      this.$swal({
        title: 'Xoá lệnh đã từ chối?', icon: 'warning', showCancelButton: true,
        confirmButtonText: 'Xoá', cancelButtonText: 'Huỷ',
      }).then(result => {
        if (!result.value) return;
        this.$service.delete(`${this.service}/${item._id}`).then(() => {
          this.$swal({ title: 'Đã xoá', icon: 'success', toast: true, position: 'top-end', timer: 2000 });
          this.load();
        }).catch(error => {
          const msg = error.response && error.response.data && (error.response.data.message || error.response.data.msg);
          this.$swal({ text: msg || 'Có lỗi xảy ra', icon: 'error' });
        });
      });
    },
  },
};
</script>
